import React, { useState } from "react";
import { CheckPostAward } from "../api/ApiHelper";
import { validOnlyNumber } from "./Regex";
import vIcon from '../v.svg'
import iIcon from '../i.svg'
import ReCAPTCHA from "react-google-recaptcha";

import InputMask from 'react-input-mask';
import validator from 'validator'

export default function Login(props) {

  const recaptchaRef = React.createRef();
  const [birthDate, setBirthDate] = useState('');
  const [personalNumber, setPersonalNumber] = useState("");

  const [responseErr, setResponseErr] = useState(false);

  const [typeMsg, setTypeMsg] = useState(NaN);

  const [personalNumberErr, setPersonalNumberErr] = useState(true);
  const [initShowPSErr, setInitShowPSErr] = useState(false)
  const [birthDateError, setBirthDateError] = useState(true);
  const [initShowBTErr, setInitShowBTErr] = useState(false)
  const [disableSend, setDisableSend] = useState(true);

  const [loading, setLoading] = useState(false);


  const handleClick = (e) => {
    e.preventDefault();
    //setLoading(true)
    props.onLoading(true);
    setTypeMsg(NaN)
    if (validatePersonalNumber(personalNumber)) {
      fetchData();
    }
  };

  const fetchData = async () => {
    setLoading(true)
    props.onLoading(true);
    var token
    if (window.config.USE_CAPTCH) {
      recaptchaRef.current.reset()
      token = await recaptchaRef.current.executeAsync();
    } else {
      token = '111'
    }

    const fillData = {
      BirthDate: strToDate(birthDate),
      number: personalNumber,
      googleResponseToken: token,
    }

    try {
      //const response = await CheckAward(BirthDate, personalNumber);
      const response = await CheckPostAward(fillData);
      setTypeMsg(response.data)
      setResponseErr(false)
    } catch (error) {
      setResponseErr(true)
    }
    setLoading(false)
    props.onLoading(false);
  }


  const handleKeyPress = (e) => {
    if (!(e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 46)) {
      if (validOnlyNumber.test(e.key)) e.preventDefault()
    }
  }


  const validatePersonalNumber = (val) => {
    setInitShowPSErr(true)
    setPersonalNumberErr(!(val.length > 3))
    setDisableSend(birthDateError || val.length < 4)
    return val.length > 3
  }
  const validateDate = (value) => {
    setInitShowBTErr(true)
    setBirthDate(value)
    let validDate
    if (validator.isDate(value, 'dd/MM/yyyy')) {
      var dateParts = value.split("/");
      if (dateParts[2] < 1900 || dateParts[2] > 2006) {
        validDate = false
      } else {
        validDate = true
      }
    } else {
      validDate = false
    }
    setBirthDateError(!validDate)
    setDisableSend(!validDate || personalNumberErr)
  }
  const strToDate = (dateString) => {

    if (!validator.isDate(dateString, 'dd/MM/yyyy')) return null
    var dateParts = dateString.split("/");
    //return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    return new Date(Date.UTC(dateParts[2], dateParts[1] - 1, dateParts[0]));
  
  }

  return (
    <div className="mainform">

      <h1>זכאים לאות המערכה ללחימה ברצועת הביטחון?</h1>
      <div className='txtexplain'>לבדיקת זכאות יש להזין מספר אישי ותאריך לידה</div>

      <div className="inputs ">

        <div >מספר אישי</div>
        <input
          className='flex-grow-1'
          type="text"
          name="name"
          maxLength='9'
          value={personalNumber}
          onChange={(e) => { setPersonalNumber(e.target.value); validatePersonalNumber(e.target.value) }}
          onKeyDown={handleKeyPress}
          //onFocus={(e) => { validatePersonalNumber(e.target.value) }}
          onBlur={(e) => { validatePersonalNumber(e.target.value) }}


        ></input>
      </div>
      <div className="inputs ">
        <div> תאריך לידה</div>
        <InputMask mask="99/99/9999" className="inputDate" value={birthDate}  onChange={(e) => validateDate(e.target.value)}
        />

      </div>
      <div className="d-flex justify-content-between">
        <button disabled={disableSend} className='btn btn-primary' type="button" onClick={handleClick}>בדיקה
          {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
        </button>
        <a href={window.config.OBJECTION_URL} className="align-self-end" rel="noreferrer" target='_blank' >להגשת ערעור</a>
      </div>


      <div style={{ display: typeMsg ? "block" : "none" }}
        className="msg approved"
      ><img alt='נמצאת זכאי' src={vIcon} className='imgIcon' />
        נמצאת זכאי לאות המערכה ללחימה ברצועת הבטחון
      </div>
      <div style={{ display: typeMsg === false ? "block" : "none" }}

        className="msg notApproved"
      ><img alt='לא נמצאת זכאי' src={iIcon} className='imgIcon' />
        עפ"י הרישומים אצלנו, אינך זכאי לקבלת אות המערכה.
      </div>

      {responseErr && <div className="msg notApproved">
        <img alt='error' src={iIcon} className='imgIcon' />
        אירעה שגיאה בלתי צפויה.      </div>}


      {initShowPSErr && personalNumberErr && <div className="msg notApproved">
        <img alt='קלט לא תקין' src={iIcon} className='imgIcon' />
        <span>מספר אישי לא תקין</span>
      </div>}
      {initShowBTErr && birthDateError && <div className="msg notApproved">
        <img alt='תאריך לא חוקי' src={iIcon} className='imgIcon' />
        <span>תאריך לא חוקי</span>
      </div>}



      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={window.config.SITE_KEY}
      />
    </div>

  );
}
